import axios from "./axios";
import language from "./language";

declare type RegisterForm = {
    first_name: string,
    last_name: string,
    phone_area_code: string,
    phone: string,
    password: string,
    email: string,
    country_region: number,
    district: number,
    birth_date_year: number | null,
    birth_date_month: number,
    gender: string,
    interests: number[],
    receive_email: number,
    receive_newsletter: number,
    recaptcha_token?: string,
    recaptcha?: string,
}

export default async (data: RegisterForm) => {


    const d: any = Object.assign({}, data);

    d.interest = d.interest.join(",");
    if (d.receive_email) {
        d.receive_email = 1;
    } else {
        d.receive_email = 0;
    }

    if (d.receive_newsletter) {
        d.receive_newsletter = 1;
    } else {
        d.receive_newsletter = 0;
    }

    d.lang = language();

    //d.recaptcha_token = await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    //d.recaptcha_token = recaptcha_token;

    return await axios.post("user/register", d);


}







